import { DriverRegistrationEventLogNoAuthService } from '@gen/eventLog/driverRegistrationEventLogNoAuth';
import { HttpClientBoltServer } from '@bolteu/http-client-bolt-server';
import { getServerHost } from '../common/environment';
import { PORTAL_VERSION } from '../env';

const documentsHttpClient =
  new HttpClientBoltServer<DriverRegistrationEventLogNoAuthService.HttpClientConstraints>(
    {
      baseUrl: getServerHost(),
    }
  );

documentsHttpClient.init({
  standardRequestStrategy: {
    getStandardRequest: () => {
      return {
        version: PORTAL_VERSION,
      };
    },
  },
});

const eventLogApiClient = new DriverRegistrationEventLogNoAuthService.ApiClient(
  {
    httpClient: documentsHttpClient,
  }
);

export default eventLogApiClient;
